export default {
  methods: {
    getLoyerMensuel (post) {
      return post.loyer_mensuel != null
        ? post.loyer_mensuel
        : post.loyer_mensuel_cc != null
          ? post.loyer_mensuel_cc
          : post.prix
    }
  }
}
